import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import React from "react";
import { getExportPackingList } from "../../infrastructure/redux/PackingListSlice";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const PackingListExportButton = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const { loading, date, type } = useAppSelector((state) => state.packingList);

  const handleClick = async function () {
    const response = await dispatch(
      getExportPackingList({ date, type }),
    ).unwrap();

    console.log(response);
    if (response?.url) {
      const link = document.createElement("a");
      link.href = response.url;
      link.download = response.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Button
      variant={"primary"}
      className="btn-sm"
      onClick={handleClick} // eslint-disable-line @typescript-eslint/no-misused-promises
      disabled={loading}
    >
      {t("Download packing list")}
    </Button>
  );
};
